import { DisabledPrompt, useRoute, useWorkflow, useBCMSContext, BCMSRecord, useStateManager} from "bcms-react";
import { CenterContentContainer, ContentHeaderView, FormContainer, FormRowView, PageContainer, PageContentView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { PrimaryButton, SecondaryButton } from "components/ui";
import UIPhoneNumberInput from "components/ui/UIPhoneNumberInput";
import React from "react";
import Classes, { UserAccount } from "model";


import "./mobile.css";
import "./styles.css";

/**
 * @function PhoneNumberPage
 * @return {React.Component}
 * @exported true
 * @description The main component for PhoneNumberPage
 */
export default function PhoneNumberPage(props) {
    const workflow = useWorkflow();
    const hasWorkflow = workflow ? true : false;
     const { goStep } = useWorkflow() ?? {};
    const navigate = useRoute();

      const globalController = useBCMSContext();
        BCMSRecord.globalControllerFor(Classes, globalController);
        const data = { ...getDefaultData(), ...props.data ?? {} };
        const ui = { ...getDefaultUI(), ...props.ui ?? {} };

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,
        onCancel: ()=>{
            if(hasWorkflow){
                goStep(0);
            }else{
                navigate("/profile");
            }
        }
    })
    return (
        <PageContainer className="phone-number-page" state={ { data, ui } } controller={ controller }>
            <PhoneNumberPageContent />
        </PageContainer>
    )
}

export const getDefaultData = () => ({
   // no data for now
  });
  
  export const getDefaultUI = () => ({
    // no ui changes for now
  });


/**
 * @function PhoneNumberPageContent
 * @return {React.Component}
 * @exported false
 * @description The page content component for PhoneNumberPage
 */
function PhoneNumberPageContent(props) {
    const {onCancel} = useStateManager();

    return(
        <PageContentView>
        <CenterContentContainer>
            <ContentHeaderView text="Change Your Phone Number" />
            <FormContainer className="small-form-width">
                <FormRowView text="*Please enter your primary phone number">
                    <UIPhoneNumberInput />
                </FormRowView>
                <FormRowView text="*Please enter your mobile phone number">
                    <UIPhoneNumberInput />
                </FormRowView>
                <FormRowView text="Please enter your work phone number">
                    <UIPhoneNumberInput />
                </FormRowView>
                <FormButtonRow>
                    <SecondaryButton text="Cancel" onClick={onCancel}/>
                    <DisabledPrompt>
                        <PrimaryButton text="Update" />
                    </DisabledPrompt>
                </FormButtonRow>
            </FormContainer>
        </CenterContentContainer>
    </PageContentView>
    )
}